import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {usStates} from './assets/usStates';
import {countries} from './assets/countries';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        member: {
            contact: {
                first_name: '',
                middle_name: '',
                last_name: '',
                primary_degree: '',
                address_1: '',
                address_2: '',
                city: '',
                state: '',
                country: '',
                zip: '',
                email: '',
                phone: '',
                acs_number: ''
            },
            attachments: [
                {
                    "name": "training_proof",
                    "label": "Please attach proof of your in-training status.",
                    "file": "",
                    "link": "",
                },
                {
                    "name": "test",
                    "label": "test",
                    "file": "",
                    "link": "www.google.com",
                },
            ],
            meeting: {
                previouslyRegistered: {
                    isRegistered: 'choose',
                    enteredMeetingEmail: '',
                    meetingID: '',
                    firstName: '',
                    lastName: '',
                    city: '',
                    state: '',
                    purchasedProducts: [],
                    attempted: false
                },
                registrationProducts: '',
                registrationSelected: '',
                extraProducts: '',
                extraProductsSelected: [],
                meetingInfo: '',
                requiredAttachments: '',
                extra: ''
            },
        },
        donation: {
            amount: 0,
        },
        mulligan_pack: {
            amount: 0,
        },
        payment: {
            cc: {
                number: '',
                firstName:
                    '',
                lastName:
                    '',
                expiry:
                    '',
                cvv:
                    '',
                type:
                    ''
            }
            ,
            response: {
                code: '',
                text:
                    '',
                authnetID:
                    '',
                paymentID:
                    '',
                errorMsg:
                    '',
                master: '',
                receiptTo: ''
            }
        },
        appStage: {
            currentProgress: 'start',
            updateRegCurrentProgress: 'lookup',
            sendingAttachments: false,
            states: usStates,
            countries: countries
        },
        loading: false,
    },
    getters: {
        getState(state) {
            return state;
        }
        ,
    },
    mutations: {
        setupForm: function (state) {

            let regType = state.member.meeting.registrationSelected.name;
            let attachments = [];

            switch (regType) {
                case 'Resident/Fellow/Student Registration':

                    attachments = [
                        'training_proof',
                    ];

                    break;
                //add more cases for different reg type requirements
            }


            state.member.meeting.requiredAttachments = attachments;


            state.member.attachments = state.member.attachments.filter((attachemtSet) => {
                if (state.member.meeting.requiredAttachments.includes(attachemtSet.name)) {
                    return attachemtSet;
                }
            });

            state.appStage.currentProgress = 'form'


        },
        applicationResponse: function (state, payload) {

            state.payment.response.code = payload.formatResponse.code;
            state.payment.response.text = payload.formatResponse.text;
            state.payment.response.authnetID = payload.formatResponse.authnetID;
            state.payment.response.paymentID = payload.formatResponse.paymentID;
            state.payment.response.errorMsg = payload.formatResponse.errorMsg;
            state.payment.response.master = payload.master;
            state.payment.response.receiptTo = payload.receiptEmail;

            if (payload.formatResponse.code == 1 || payload.formatResponse.code == 0) {
                state.appStage.currentProgress = 'success';
            }

        },
        addNewMultiple(state, fieldSetName) {
            state.member.fieldSets.map((fieldSet) => {
                if (fieldSet.name === fieldSetName) {
                    let template = fieldSet.fields[0].fields[0];
                    fieldSet.fields[0].fields.push(template);
                }
            });


        },
        addPreviousReg(state, data) {
            if (data.status === "OK") {
                state.member.meeting.previouslyRegistered.isRegistered = true;
                state.member.meeting.previouslyRegistered.meetingID = data.reg.MEETINGID;
                state.member.meeting.previouslyRegistered.firstName = data.reg.first_name;
                state.member.meeting.previouslyRegistered.lastName = data.reg.last_name;
                state.member.meeting.previouslyRegistered.city = data.reg.city;
                state.member.meeting.previouslyRegistered.state = data.reg.state;
                state.member.meeting.previouslyRegistered.purchasedProducts = data.products;
            } else {
                state.member.meeting.previouslyRegistered.attempted = true;
            }

        },
        addRates(state, data) {
            state.member.meeting.registrationProducts = data.reg;
            state.member.meeting.extraProducts = data.extra;
            state.member.meeting.meetingInfo = data.meeting;
        },
        continueUpdateRegForm(state, stage) {
            state.appStage.updateRegCurrentProgress = stage;
        },
        editOrder(state) {
            state.appStage.currentProgress = 'lookup';
        },
        toggleLoading(state) {
            state.loading = !state.loading;
        },


    },
    actions: {
        getPreviousRegistration: function (context) {

            context.commit('toggleLoading');

            //send lookup member request
            let enteredEmail = context.state.member.meeting.previouslyRegistered.enteredMeetingEmail;

            axios.get('https://db.fvs.org/api/meeting/find/' + enteredEmail).then(function (response) {
                context.commit('toggleLoading');

                //console.log(response);
                context.commit('addPreviousReg', response.data);
            });


        },
        getRates: function (context) {
            context.commit('toggleLoading');

            //send lookup member request

            axios.get('https://db.fvs.org/api/meeting/rates').then(function (response) {
                context.commit('toggleLoading');

                //console.log(response);
                context.commit('addRates', response.data);
            });


        },
        saveForm: function (context, total) {

            context.commit('toggleLoading');

            let data = {
                cc: context.state.payment.cc,
                total: total,
                reg_product: context.state.member.meeting.registrationSelected.MEETINGPRODUCTID,
                contact: context.state.member.contact,
                extra: context.state.member.meeting.extraProductsSelected,
                donation: context.state.donation,
                mulligan_pack: context.state.mulligan_pack
            };


            let apiConfig = {
                data: data,
                method: 'post',
                url: 'https://db.fvs.org/api/meeting/store',
                headers: {'Content-Type': 'application/json'},
            };

            axios(apiConfig).then(
                response => {

                    context.commit('toggleLoading');

                    let formatResponse = {
                        code: '',
                        text: '',
                        authnetID: '',
                        paymentID: '',
                        errorMsg: ''
                    };

                    if (response.data.status == 'OK') {

                        formatResponse.code = response.data.transaction.authnet_result;
                        formatResponse.text = response.data.transaction.authnet_description;
                        formatResponse.authnetID = response.data.transaction.authnet_trans_id;
                        formatResponse.paymentID = response.data.transaction.PAYMENTID;
                    } else {
                        formatResponse.errorMsg = response.data.data.message;

                    }
                    let payload = {
                        formatResponse: formatResponse,
                        master: response.data.reg,
                        receiptEmail: response.data.receiptTo,
                    };

                    context.commit('applicationResponse', payload);
                    context.dispatch('uploadAttachments');
                }
            );
        },
        saveUpdateForm: function (context, total) {

            context.commit('toggleLoading');

            let data = {
                cc: context.state.payment.cc,
                total: total,
                extra: context.state.member.meeting.extraProductsSelected,
                donation: context.state.donation,
                mulligan_pack: context.state.mulligan_pack,
                meetingID: context.state.member.meeting.previouslyRegistered.meetingID
            };


            let apiConfig = {
                data: data,
                method: 'post',
                url: 'https://db.fvs.org/api/meeting/update',
                headers: {'Content-Type': 'application/json'},
            };

            axios(apiConfig).then(
                response => {

                    context.commit('toggleLoading');

                    let formatResponse = {
                        code: '',
                        text: '',
                        authnetID: '',
                        paymentID: '',
                        errorMsg: ''
                    };

                    if (response.data.status == 'OK') {

                        formatResponse.code = response.data.transaction.authnet_result;
                        formatResponse.text = response.data.transaction.authnet_description;
                        formatResponse.authnetID = response.data.transaction.authnet_trans_id;
                        formatResponse.paymentID = response.data.transaction.PAYMENTID;
                    } else {
                        formatResponse.errorMsg = response.data.data.message;

                    }
                    let payload = {
                        formatResponse: formatResponse,
                        master: response.data.reg,
                        receiptEmail: response.data.receiptTo,
                    };

                    context.commit('applicationResponse', payload);

                }
            );
        },
        uploadAttachments(context) {

            context.state.appStage.sendingAttachments = true;

            let formData = new FormData();
            formData.append('MEETINGID', context.state.payment.response.master.MEETINGID);

            let atchmnts = context.state.member.attachments;

            for (let i = 0; i < atchmnts.length; i++) {
                formData.append(atchmnts[i].name, atchmnts[i].file);
                // console.log(atchmnts[i].name + " " + atchmnts[i].file);
            }


            axios.post('https://db.fvs.org/api/meeting/store/attachments',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function () {
                context.state.appStage.sendingAttachments = false;
            })
                .catch(function () {
                    alert('There was an issue uploading your attachments!');
                });
        }
    }
})